import { I18n } from '@calendly/i18n';
import { EditPencilIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
const timingsWrapperCss = "t7tdt3n";
export const TimingsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timingsWrapperCss, props.className)} />;
});
const editItemCss = "egmh2lk";
export const EditItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(editItemCss, props.className)}>
    <EditPencilIcon size="large" />
    {I18n.t('publisher.action.edit')}
  </Item>);

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");